export function joinLinks(...links: (string | undefined)[]): string {
    return links
        .map((part) => part?.replace(/^\/+|\/+$/g, ''))
        .filter(Boolean)
        .join('/');
}
